module.exports = {
  Experiment: require('./lib/Experiment').default,
  Variant: require('./lib/Variant').default,
  emitter: require('./lib/emitter').default,
  experimentDebugger: require('./lib/debugger'),
  mixpanelHelper: require('./lib/helpers/mixpanel').default,
  segmentHelper: require('./lib/helpers/segment').default,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@marvelapp/react-ab-test/index.js
// module id = 381
// module chunks = 27